<template>
    <div>
        <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2">
        </div>

        <v-data-table :headers="headersTabs" :items="desserts" item-key="name" :search="search" :items-per-page="10"
            class="elevation-1 table text-center align-middle table-students-admin small" loading loading-text="Cargando..."
            mobile-breakpoint="0" :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50],
                }">

            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.id }}</td>
                    <td class="text-start-mb">{{ row.item.name }}</td>
                    <td> {{ row.item.usuarios_inscritos }} </td>
                    <td> {{ row.item.rutas_inscritas }} </td>
                    <td> {{ row.item.estado }} </td>
                    <td></td>
                    <td class="d-flex gap-2">
                        <button type="button" class="text-primary me-2" alt="Editar curso" title="Editar curso"
                            @click.prevent="editarCurso(row.item)">
                            <i class="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button type="button" class="text-primary" data-bs-toggle="modal" data-bs-target="#deleteModal"
                            alt="Eliminar curso" title="Eliminar curso" @click="destroy = row.item">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </td>
                </tr>
            </template>
        </v-data-table>
        
        <!-- Eliminar curso modal -->
        <div class="modal fade" id="deleteModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="deleteModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-danger">
                        <h5 class="modal-title">
                            Eliminar curso {{ destroy.name }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        <span id="response">¿Esta seguro de eliminar el curso <strong>{{ destroy.name }}</strong>?</span>
                    </div>
                    <div class="modal-footer">
                        <button id="close" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" @click="destroy = []">Cerrar</button>
                        <button id="delete" type="button" @click="eliminarCurso" class="btn btn-outline-danger">Eliminar curso</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "urlcourses"
    ],
    data() {
        return {
            search: "",
            headersTabs: [
                { text: "No. de Curso", value: "ind" },
                { text: "Nombre del curso", value: "firstname" },
                { text: "Usuarios Inscritos", value: "usuarios_inscritos", },
                { text: "Rutas Inscritas", value: "rutas_inscritas", },
                { text: "Estado", value: "estado", },
            ],
            url: this.urlcourses,
            desserts: [],
            routesSelected: [],
            courseAddName: "",
            courseIdUser: "",
            edit: [],
            destroy: [],
            error: [],
            listadoAreas: [],
            listadoNivel: [],
            showFilters: false,
            busqueda: { name: "", lastname: "", email: "", client: "" }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let param = "";//"?withUsers=true";
            axios.post(this.url + param).then((res) => {
                this.desserts = res.data;
            });
        },
        editarCurso(course) {
            window.location.href = course.editUrl;
        },
        eliminarCurso() {
            /*const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar";
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });*/
        },
        
    },
};
</script>
